let path = `${window?.location?.origin ?? process.env.REACT_APP_DASHBOARD}`;

export const defaultFilters = {
  bg_type: "pattern",
  bg_color: "",
  style_id: "style_1",
  box_color: "",
  offer_text: "",
  description: "",
};

export const staticFilters = {
  bg_type: "pattern",
  bg_color: "",
  style_id: "style_1",
  box_color: "",
  offer_text: "",
  description: "",
};

export const posterStyleList = [
  {
    id: "style_1",
    label: "Style 1",
    image: "pattern_8",
  },
  {
    id: "style_2",
    label: "Style 2",
    config: {},
    image: "pattern_4",
  },
  {
    id: "style_3",
    label: "Style 3",
    config: {},
    image: "pattern_13",
  },
  {
    id: "style_4",
    label: "Style 4",
    config: {},
    image: "pattern_22",
  },
  {
    id: "style_5",
    label: "Style 5",
    config: {},
    image: "pattern_7",
  },
];

export const posterStyleConfig = {
  style_1: {
    text_color: "#0a0a29",
    bg_color: "",
    bg_path: `${path}/images/pattern_8.jpg`,
    box_color: "#fff",
  },
  style_2: {
    text_color: "#0a0a29",
    bg_color: "",
    bg_path: `${path}/images/pattern_4.jpg`,
    box_color: "#FBFFF6",
  },
  style_3: {
    text_color: "#0a0a29",
    bg_color: "",
    bg_path: `${path}/images/pattern_13.jpg`,
    box_color: "#FBFDF8",
  },
  style_4: {
    text_color: "#0a0a29",
    bg_color: "",
    bg_path: `${path}/images/pattern_22.jpg`,
    box_color: "#F6FCFF",
  },
  style_5: {
    text_color: "#0a0a29",
    bg_color: "",
    bg_path: `${path}/images/pattern_7.jpg`,
    box_color: "#ffffff",
  },
};
